'use client';

import { useStore } from '@/providers/app-store-provider';
import { isEmpty, isInZeloolApp } from '@/utils/tools';
import { useEffect } from 'react';
import InstadeskPop from './InstadeskPop';
import ShulexIframePop from './ShulexIframePop';
import { env } from '@/utils/env';
/**
 * 加载 Zendesk 脚本
 */
function loadZendesk() {
  const oScript = document.createElement('script');
  oScript.type = 'text/javascript';
  oScript.id = 'ze-snippet';
  oScript.async = !0;
  oScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${env.NEXT_PUBLIC_ZENDESK_KEY}`;
  // app中不加载客服插件
  if (!isInZeloolApp()) {
    document.head.appendChild(oScript);
    // 客服插件加载完成后，再执行打招呼配置数据的获取，防止点击客服气泡无效
    oScript.onload = () => {
      return Promise.resolve();
    };
  }
}

/**
 * 客服弹窗组件
 *
 * 在 layout.tsx 中使用，统一管理全局客服弹窗
 * - 负责初始化客服配置（加载脚本等）
 * - 负责展示和隐藏弹窗
 * - 状态通过全局 store 管理
 */
export default function CustomerServicePopups() {
  const publicResourceData = useStore((state) => state.publicResourceData);
  const isMobile = useStore((state) => state.isMobileScreen);

  // 从全局 store 读取状态
  const customerService = useStore((state) => state.customerService);
  const setCustomerService = useStore((state) => state.setCustomerService);

  /**
   * 初始化客服配置
   */
  useEffect(() => {
    const initData = async () => {
      if (!publicResourceData?.jsonvalues) {
        return;
      }

      const customerServiceConfig = {
        instadesk_chat: publicResourceData.jsonvalues.instadesk_chat,
        prescription_recognition_open: publicResourceData.jsonvalues.prescription_recognition_open,
        customer_service_popup: publicResourceData.jsonvalues.customer_service_popup,
      };

      const {
        enable_instadesk_pc,
        enable_instadesk_m,
        instadesk_url = '',
        id,
        token,
        desk_type,
      } = customerServiceConfig.instadesk_chat;

      const isEnableInstadesk = isMobile ? enable_instadesk_m : enable_instadesk_pc;
      const finalDeskType = isEnableInstadesk ? 'instadesk' : 'zendesk';

      setCustomerService({ deskType: finalDeskType });

      // Shulex：iframe 方案，不下发 embed.js；id/token 保留给配置校验
      if (desk_type && id && token && desk_type === 'shulex') {
        setCustomerService({ deskType: 'shulex', shulexIframeUrl: instadesk_url });
        return;
      }

      setCustomerService({ instadeskUrl: instadesk_url });

      // 处理 Zendesk 弹窗配置（如果需要）
      if (!isEmpty(customerServiceConfig.customer_service_popup)) {
        if (finalDeskType === 'zendesk') {
          await loadZendesk();
        }
      }
    };

    initData();
  }, [publicResourceData, isMobile, setCustomerService]);

  return (
    <>
      <InstadeskPop
        show={customerService.showInstadesk}
        instadeskUrl={customerService.instadeskUrl}
        onClose={() => setCustomerService({ showInstadesk: false })}
      />
      <ShulexIframePop
        show={customerService.showShulexIframe}
        iframeUrl={customerService.shulexIframeUrl}
        onClose={() => setCustomerService({ showShulexIframe: false })}
      />
    </>
  );
}
